import { useState, useEffect, useRef } from "react";

import { useSchool, useSettings } from "@app/shared/lib/hooks";
import { isEmpty } from "@app/shared/lib/is-empty";

type Props = {
  orderId?: string;
  licenseId?: string;
};
const PaymentView: React.FC<Props> = ({ orderId, licenseId }) => {
  const school = useSchool();
  const settings = useSettings();

  const [checkoutUrl] = useState(() => {
    if (!isEmpty(orderId)) {
      const url = new URL(
        settings.checkout.orderUrl
          .replace("{schoolNumber}", school.number.toString())
          .replace("{orderId}", orderId!),
      );

      return url.toString();
    }

    if (!isEmpty(licenseId)) {
      const url = new URL(
        settings.checkout.subscriptionUrl
          .replace("{schoolNumber}", school.number.toString())
          .replace("{licenseId}", licenseId!),
      );

      return url.toString();
    }
  });

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!checkoutUrl || !ref.current) return;
    const iframe = document.createElement("iframe");
    iframe.src = checkoutUrl;
    iframe.style.width = "100%";
    iframe.style.height = "800px";
    iframe.style.border = "none";
    iframe.style.overflow = "hidden";
    ref.current.appendChild(iframe);

    const onMessage = (
      e: MessageEvent<
        | { type: "resize"; height: number; width: number }
        | { type: "redirect"; href: string }
        | { type: "emulateClick"; href: string; target: string }
      >,
    ) => {
      if (e.data.type === "resize") {
        if (e.data.height) {
          iframe.style.height = `${e.data.height}px`;
        }

        if (e.data.width) {
          iframe.style.width = `${e.data.width}px`;
        }
      }

      if (["redirect", "redirect-top"].includes(e.data.type) && e.data.href) {
        document.location.href = e.data.href;
      }

      if (e.data.type === "emulateClick" && e.data.href) {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = e.data.href;
        if (e.data.target) a.target = e.data.target;
        a.click();
        a.remove();
      }
    };

    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    } else {
      window.onmessage = onMessage;
    }

    return () => {
      if (window.removeEventListener) {
        window.removeEventListener("message", onMessage, false);
      } else {
        window.onmessage = null;
      }

      iframe.remove();
    };
  }, [checkoutUrl]);

  return <div className="w-100" style={{ height: "800px" }} ref={ref} />;
};

export default PaymentView;
